import Carousel from './src/main';
import '@/theme/css/basic/carousel.scss';

/* istanbul ignore next */
// Carousel.install = function(Vue) {
//   Vue.component(Carousel.name, Carousel);
// };

export default Carousel;